import { useState } from "react";
import { Helmet } from "react-helmet";
// Import all images from cocImg folder
import c1 from "../../assets/cocImg/cococ2.jpeg";
import c2 from "../../assets/cocImg/cocimg1.jpeg";
import c3 from "../../assets/cocImg/cocimg2.jpeg";
import c4 from "../../assets/cocImg/cocimg3.jpeg";
import c7 from "../../assets/cocImg/cococ5.jpeg";
import c8 from "../../assets/cocImg/cocimg5.jpeg";
import c9 from "../../assets/cocImg/cocimg6.jpeg";
import c10 from "../../assets/cocImg/cocimg7.jpeg";
import c11 from "../../assets/cocImg/cocimg8.jpeg";
import c12 from "../../assets/cocImg/cococ4.jpeg";
import c13 from "../../assets/cocImg/cocimg10.jpeg";
// import c14 from "../../assets/cocImg/cocimg11.jpeg";
import c15 from "../../assets/cocImg/cocimg12.jpeg";
import c16 from "../../assets/cocImg/cocimg13.jpeg";
import c17 from "../../assets/cocImg/cocimg14.jpeg";
import c18 from "../../assets/cocImg/cocimg15.jpeg";
import c19 from "../../assets/cocImg/cocimg16.jpeg";
// import c20 from "../../assets/cocImg/c20.jpeg";
// import c21 from "../../assets/cocImg/c21.jpeg";

const images = [
  c15, c4, c3, c16, c17, c8, c9, c10, c11, c12, c13, c18, c1, c2, c7, c19
];


const PromoteGallery = () => {
  const [modalImg, setModalImg] = useState(null);

  return (
    <section className="my-16 max-w-7xl mx-auto px-4">
      <Helmet>
        <title>Tirumala Cocopeat | Best Cocopeat Exporters Andhra Pradesh</title>
        <meta name="description" content="View the promotional gallery of Tirumala Cocopeat, the leading cocopeat exporter and supplier in Andhra Pradesh, Anantapur. Explore our products, facilities, and export highlights." />
        <meta name="keywords" content="Tirumala Cocopeat, promotional gallery, cocopeat exporters, best cocopeat in Andhra Pradesh, best cocopeat in Anantapur, cocopeat suppliers, cocopeat manufacturers, cocopeat India, cocopeat for export, cocopeat exporters, exports, premium cocopeat, organic cocopeat, cocopeat business, cocopeat company, cocopeat images, cocopeat highlights, cocopeat facilities" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Promotional Gallery | Tirumala Cocopeat | Best Cocopeat Exporters Andhra Pradesh" />
        <meta property="og:description" content="View the promotional gallery of Tirumala Cocopeat, the leading cocopeat exporter and supplier in Andhra Pradesh, Anantapur. Explore our products, facilities, and export highlights." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tirumalacocopeat.vercel.app/cocImg-gallery" />
      </Helmet>
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-extrabold text-green-800 mb-2 tracking-tight drop-shadow-sm">Tirumala Cocopeat Highlights & Export Gallery</h2>
        <p className="text-gray-500 text-lg md:text-xl max-w-2xl mx-auto">Explore our latest promotional visuals and highlights. Click any image to view in detail.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 overflow-hidden cursor-pointer relative border border-gray-100 hover:border-green-300"
            onClick={() => setModalImg(img)}
          >
            <img
              src={img}
              alt={`Promote ${idx + 1}`}
              className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-green-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-2">
              <span className="text-white text-xs font-semibold drop-shadow">Click to enlarge</span>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for image preview */}
      {modalImg && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm transition-all"
          onClick={() => setModalImg(null)}
        >
          <div className="relative max-w-2xl w-full mx-4" onClick={e => e.stopPropagation()}>
            <button
              className="absolute -top-4 -right-4 bg-white rounded-full shadow p-2 hover:bg-red-500 hover:text-white transition-colors z-10"
              onClick={() => setModalImg(null)}
              aria-label="Close preview"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={modalImg}
              alt="Promote Preview"
              className="w-full max-h-[80vh] object-contain rounded-xl border-4 border-white shadow-2xl"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default PromoteGallery;
